import LogisticsCompany from "@/enum/LogisticsCompany";
import WaybillTemplatePrintType from "@/enum/WaybillTemplatePrintType";

import WaybillTemplateType from "@/enum/WaybillTemplateType";

import TemplateFieldDTO from "./TemplateFieldDTO";
import ServiceOption from "../ewaybillAccount/ServiceOptionDTO";

export enum ShipperPrivacyProtectionType {
    NAME = "NAME",
    MOBILE = "MOBILE",
    STREET = "STREET",
    ALL_STREET = "ALL_STREET",
}

export default interface WaybillTemplateDTO {
    allowedShopIds?: string;

    allowedShopIdsArray?: string[];

    bindingPrinter: string;

    bindingShopIds: string;

    bindingShopIdList: number[];

    companyId: number;

    customAreaHeight?: number;

    customAreaLeft: number;

    customAreaPrintTemplateUrl: string;

    customAreaTop: number;

    customAreaWidth?: number;

    defaultShippingAddressId: number;

    deleted: boolean;

    enableEmptyShortAddressCheck: boolean;

    /**
     * 只有电子面单才有此字段
     * 申请地址id
     */
    ewaybillShippingAddressId: number;

    fields: TemplateFieldDTO[];

    forceNoPageMargins: boolean;

    height: number;

    id: number;

    index: number;

    is3PartsWaybill: boolean;

    isPrintBottomLogo: boolean;

    isPrintTopLogo: boolean;

    isSystemTemplate: boolean;

    logisticsCompany: LogisticsCompany;

    name: string;

    offsetLeft: number;

    offsetTop: number;

    picture: string;

    printTemplateId: string;

    printTemplateUrl: string;

    printType: WaybillTemplatePrintType;

    serviceOptions: string;

    shopId: number;

    supportsChildWaybillNoMode: boolean;

    systemTemplateId: number;

    thumbnail: string;

    type: WaybillTemplateType;

    width: number;

    lastUpdated?: string;

    /** 是否脱敏发货人 */
    shipperPrivacyProtection?: boolean;

    templateVersion?: number;

    shipperPrivacyProtectionTypes: ShipperPrivacyProtectionType[];

    /** 只有系统模板有 */
    supportedServiceOptions: ServiceOption[];
}
